import { Message } from 'element-ui';

/** query-string  stringify 序列化
 *
 * @param {*} obj	search参数对象
 * @param {*} opt.encode 是否编码 keys 和 values
 * @param {*} opt.skipNull 是否跳过值为 null 的属性
 * @param {*} opt.skipEmptyString 是否跳过值为 '' 的属性
 * @param {*} opt.seq 分隔符，默认为 '&'
 * @param {*} opt.prefix 添加前缀，默认为 ''
 * @returns
 */
export function qsStringify(obj = {}, opt = {}) {
  let str = '';
  let result = [];
  let { encode, skipNull, skipEmptyString, seq = '&', prefix = '' } = opt;

  if (Object.prototype.toString.call(obj) === '[object Object]') {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      let value = obj[key];
      if (encode) key = encodeURIComponent(key);

      if (value === null) {
        if (!skipNull) result.push(key);
        continue;
      }

      if (value === '') {
        if (!skipEmptyString) result.push(`${key}=`);
        continue;
      }

      if (value !== undefined) {
        if (encode) value = encodeURIComponent(value);
        result.push(`${key}=${value}`);
      }
    }

    if (result.length === 0) prefix = '';
    str = prefix + result.join(seq);
    return str;
  } else {
    throw new Error('第一个参数必须是对象');
  }
}


/** query-string parse 反序列化
 *
 * @param {*} link 链接
 * @param {*} opt.decode 是否解码，默认为 true
 * @param {*} opt.parseNumbers 是否把数字类型的值转化为数字，默认为 false
 * @param {*} opt.parseBooleans 是否把布尔类型的值转化为boolean，默认为 false
 * @param {*} opt.key 获取指定参数的值
 */
export function qsParse(link, opt = {}) {
  const result = {};
  const { decode = true, parseNumbers, parseBooleans, key:searchKey } = opt;

  let url = link ? link : window.location.href;
  if (url.includes('#/')) url = url.split('#/')[1];
  if (url.includes('#')) url = url.split('#')[0];
  if (url.includes('=')) url = '?' + url;
  if (!url.includes('?')) {
    if (searchKey) return '';
    return result;
  }
  url = url.slice(url.lastIndexOf('?') + 1);
  const searchArr = url.split('&');

  for (let i = 0; i < searchArr.length; i++) {
    const item = searchArr[i];
    if (item === '') continue;
    if (!item.includes('=')) {
      const key = decode ? decodeURIComponent(item) : item;
      result[key] = null;
      continue;
    }

    let [key, value] = item.split('=');

    // 解码
    if (decode) {
      key = decodeURIComponent(key);
      value = decodeURIComponent(value);
    }

    if (value !== '') {
      // 格式化数字
      if (parseNumbers) {
        const formatValue = Number(value);
        if (Number.isFinite(formatValue)) value = formatValue;
      }
      // 格式化 Boolean
      if (parseBooleans) {
        if (value === 'true') value = true;
        if (value === 'false') value = false;
      }
    }

    if (Reflect.has(result, key)) {
      result[key] = [].concat(result[key], value);
    } else {
      result[key] = value;
    }
  }

  if (searchKey) return result[searchKey] || '';
  return result;
}
// 获取链接指定 key 的 value 值
export function getQueryValue(key, link, opt={}){
  return qsParse(link, {key}, opt);
}

// 添加 search 参数
export function addSearchParams(url, params = {}) {
  if (!url) {
    Message.error('无效的链接');
    return;
  }
  try {
    const u1 = new URL(url);
    const sp1 = u1.searchParams;

    let searchObj = {};
    for (let [key, value] of sp1) {
      searchObj[key] = value;
    }
    searchObj = { ...searchObj, ...params };  //同名直接覆盖，不产生多个
    const searchStr = new URLSearchParams(searchObj).toString();

    const u2 = new URL(`${u1.origin}${u1.pathname}?${searchStr}${u1.hash}`);
    // console.log(u1, u2);
    return u2.href;
  } catch (error) {
    Message.error('无效的链接');
    return;
  }
}

// 删除 search 参数
export function deleteSearchParams(url, params = []) {
  if (typeof params === 'string') params = [params];
  const u1 = new URL(url);
  const sp1 = u1.searchParams;
  
  params.forEach((item) => sp1.delete([item]));
  const searchStr = new URLSearchParams(sp1).toString();
  const u2 = new URL(`${u1.origin}${u1.pathname}?${searchStr}${u1.hash}`);
  // console.log('deleteSearchParams', u1, u2);
  return u2.href;
}